import React from "react";
import "../RecentSales/RecentSales.css";

const salesData = [
  { name: "Dan Hydraulics", email: "dan.hydraulics@email.com", amount: "+$1,999,000.00" },
  { name: "Challenger Sweepers Pvt Ltd", email: "challenger.sweepers@email.com", amount: "+$1,390,000.00" },
  { name: "MAHAVIR HYDRAULICS PVT LTD", email: "mahavir.hydraulics@email.com", amount: "+$299,000.00" },
  { name: "ELECON ENGINEERING COMPANY LIMITED", email: "Elecon.eng@email.com", amount: "+$290,000.00" },
  { name: "TECHMECH HYDRO", email: "techmech.hydro@email.com", amount: "+$39,000.00" }
];

const getInitials = (name) => {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("");
};

const TopCustomers = () => {
  return (
    <div className="recent-sales-card" style={{ height: '400px' }}>
      <div className="sales-header">
        <div className="tracking-tight text-sm font-medium">Top Customers</div>
        {/* <div className="text-xs text-muted-foreground mb-0">You made 265 sales this month.</div> */}
      </div>
      <div className="sales-list">
        {salesData.map((sale, index) => (
          <div key={index} className="sales-item">
            <span className="avatar">{getInitials(sale.name)}</span>
            <div className="sales-info">
              <p className="tracking-tight text-sm font-medium mb-0">{sale.name}</p>
              <p className="text-xs text-muted-foreground mb-0">{sale.email}</p>
            </div>
            <div className="sales-amount">{sale.amount}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopCustomers;